import React from 'react';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {makeStyles} from "@material-ui/core/styles";
import withStyles from "@material-ui/core/styles/withStyles";

const TableHeaderCell = withStyles(theme => ({
    root: {
        fontFamily: "EncodeSansBold",
        fontSize: 14,
        color: '#3b3b3b',
    }
}))(TableCell);

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '20px 32px'
    },
    tableRow: {
        height: "32px"
    },
    tableCell: {
        padding: "8px 16px"
    },
    title: {
        color: "#3D4977",
        textAlign: "center",
        fontFamily: "EncodeSansBold",
        fontSize: "13px"
    },
    numberOne: {
        color: '#bb0d66',
        fontFamily: "EncodeSansBold",
        fontSize: "14px",
    },
    notNumberOne: {
        color: '#000',
        fontFamily: "EncodeSansRegular",
        fontSize: "12px",
    }
}));


function AdviserDashboardRankingTable(props) {
    const ranking = props.ranking;
    const classes = useStyles();
    const {title} = props;

    return (
        <React.Fragment>
            <div className={classes.root}>
                <p className={classes.title}>{title}</p>
                <Table>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableHeaderCell className={classes.tableCell}>Nombre</TableHeaderCell>
                            <TableHeaderCell className={classes.tableCell} align={"center"}>Cantidad</TableHeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(ranking.map((row, index) => {
                            if (index === 0) {
                                return (
                                    <TableRow key={index} className={classes.tableRow}>
                                        <TableCell className={`${classes.numberOne} ${classes.tableCell}`}>{(row.Nombre)}</TableCell>
                                        <TableCell className={`${classes.numberOne} ${classes.tableCell}`}
                                                   align={"center"}>{row.emisiones}</TableCell>
                                    </TableRow>
                                )
                            } else
                                return (
                                    <TableRow key={index}>
                                        <TableCell className={`${classes.notNumberOne} ${classes.tableCell}`}>{(row.Nombre)}</TableCell>
                                        <TableCell className={`${classes.notNumberOne} ${classes.tableCell}`}
                                                   align={"center"}>{row.emisiones}</TableCell>
                                    </TableRow>
                                )
                        }))}
                    </TableBody>
                </Table>
            </div>
        </React.Fragment>
    );
}

export default AdviserDashboardRankingTable;